<script setup lang="ts">
// Sierra's stencil .tag: an uppercase label on hazard stripes. `accent` (the default)
// is amber, `info` blue (Sierra's .fps), `crit` red (its .battle), `combo` half and
// half, and `plain` a quiet outlined tag.
withDefaults(defineProps<{ variant?: 'accent' | 'info' | 'crit' | 'combo' | 'plain' }>(), { variant: 'accent' });
</script>

<template>
  <span class="itc-tag" :class="`itc-tag--${variant}`"><slot /></span>
</template>

<style scoped>
.itc-tag {
  display: inline-block;
  padding: 3px 8px;
  border-radius: var(--itc-r-tag);
  color: var(--itc-accent-ink);
  font-family: var(--itc-font-display);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  line-height: 1.3;
  text-transform: uppercase;
  white-space: nowrap;
}
.itc-tag--accent {
  background: repeating-linear-gradient(135deg, var(--itc-accent) 0 8px, color-mix(in srgb, var(--itc-accent) 82%, var(--itc-bg)) 8px 16px);
}
.itc-tag--info {
  background: repeating-linear-gradient(135deg, var(--itc-info) 0 8px, color-mix(in srgb, var(--itc-info) 80%, var(--itc-bg)) 8px 16px);
}
.itc-tag--crit {
  background: repeating-linear-gradient(135deg, var(--itc-crit) 0 8px, color-mix(in srgb, var(--itc-crit) 80%, var(--itc-bg)) 8px 16px);
}
.itc-tag--combo {
  background: linear-gradient(90deg, var(--itc-accent) 0 50%, var(--itc-info) 50% 100%);
}
.itc-tag--plain {
  padding: 2px 7px;
  border: 1px solid var(--itc-line);
  background: var(--itc-panel-2);
  color: var(--itc-muted);
}
</style>
